import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['Km/W'] as const;
const unit = z.literal('Km/W').default('Km/W');

const validator = AbstractMeasurement.value
    .extend({
        unit,
    })
    .default({});

export const ThermalResistivity = {
    validator,
    units,
};
